import React from 'react';
import { Monitor, Leaf, Cpu, ArrowUpRight, Layers } from 'lucide-react';
import { fallbackContent } from '../hooks/useContent';

const icons = { Monitor, Leaf, Cpu };

const Divisions = ({ items = fallbackContent.divisions }) => {
  return (
    <section id="divisions" className="py-20 lg:py-28 bg-[#f5f5f8]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <p className="section-label text-[#c9a227] mb-3">Our Divisions</p>
          <h2 className="font-display font-bold text-[#12263f] text-4xl lg:text-5xl">What We Do</h2>
          <p className="mt-4 text-gray-600">Two distinct verticals, one unified commitment to excellence and customer satisfaction.</p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {items.map((d, i) => {
            const Icon = icons[d.icon] || Layers;
            return (
              <div key={i} className="group bg-white rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                <div className="flex items-center justify-between">
                  <div className="w-12 h-12 rounded-xl bg-[#f0f1f5] flex items-center justify-center group-hover:bg-[#12263f] transition-colors">
                    <Icon size={22} className="text-[#12263f] group-hover:text-[#c9a227] transition-colors" />
                  </div>
                  <ArrowUpRight size={20} className="text-gray-300 group-hover:text-[#c9a227] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
                </div>
                <h3 className="font-display font-bold text-[#12263f] text-xl mt-6">{d.title}</h3>
                <p className="mt-3 text-gray-600 leading-relaxed">{d.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Divisions;
